/**
 *
 * CustomStripeProvider
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import Raven from 'raven-js';

import { get } from 'lodash';
import queryString from 'query-string';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

const stripePromise = loadStripe(STRIPE_PUBLIC_KEY);

/* eslint-disable react/prefer-stateless-function */
class CustomStripeProvider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  // needed or else it throws a warning on the console
  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    const params = queryString.parse(window.location.search);
    return { hasError: true, timesRefreshed: params.refresh || 0 };
  }

  componentDidCatch(error, errorInfo) {
    const message = get(error, 'message', '').toLowerCase();
    const containsStripeError = message.includes('stripe');
    const queryParams = queryString.parse(window.location.search);
    const timesRefreshed = parseInt(queryParams.refresh, 10) || 0;
    // BUG-fix: RES-3032
    if (containsStripeError && window.location.protocol === 'http:') {
      // give a little time to Raven to capture the exception before redirecting
      let timeout = 0;
      // only report the error once
      if (timesRefreshed === 0) {
        timeout = 100;
        Raven.captureException(error, { extra: errorInfo });
      }
      if (timesRefreshed >= 3) {
        // do nothing
        return;
      }

      // remove the query string as we will be appending it in a moment
      let newURL = window.location.href.split('?')[0];
      newURL = newURL.replace('http://', 'https://');
      const newQueryParams = queryString.stringify({
        ...queryParams,
        refresh: timesRefreshed + 1,
      });
      newURL = `${newURL}?${newQueryParams}`;

      setTimeout(() => window.location.assign(newURL), timeout);
    }
  }

  render() {
    if (this.state.hasError && this.state.timesRefreshed < 3) {
      return <div>Redirecting...</div>;
    }
    if (this.state.hasError) {
      return (
        <div
          style={{ margin: '50px auto', textAlign: 'center', maxWidth: 500 }}
        >
          <h1>There is something wrong</h1>
          <p>
            There has been an error while trying to navigate back to{' '}
            <a href={window.location.href}>{window.location.href}</a>. We have
            already received an incident report and will try to resolve it
            immediately.
          </p>
          <p>
            Please try refreshing the page or contact our support regarding this
            issue if it persists.
          </p>
        </div>
      );
    }
    return <Elements stripe={stripePromise}>{this.props.children}</Elements>;
  }
}

CustomStripeProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default CustomStripeProvider;
